import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

/*
  Generated class for the NodataProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class NodataProvider {

  showingNodata: boolean = false;

  //提示消息
  message: string;

  //按钮的 text
  firstBtnText: string;

  //第二个按钮的 text
  secBtnText: string;

  //点击后的回调
  firstCallback;

  //点击后的回调
  secCallback;

  constructor(public http: HttpClient) {
    console.log('Hello NodataProvider Provider');
  }

  showNodata(option: NodataOption){
    this.message = option.message;
    this.firstBtnText = option.firstBtnText;
    this.secBtnText = option.secBtnText;
    this.firstCallback = option.firstCallback;
    this.secCallback = option.secCallback;

    //这里callback 如果没有应该是 undefined？

    if(!this.message) this.message = '暂无数据';

    this.showingNodata = true;
  }

  dismissNodata(){
    this.showingNodata = false;
  }

}

export interface NodataOption{
  message?: string,
  firstBtnText?: string,
  secBtnText?: string,
  firstCallback?,
  secCallback?
}



// WEBPACK FOOTER //
// ./src/providers/nodata/nodata.ts